import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Container } from "./Styled";
import EntityList from "./entityList/EntityList";
import { Entity } from "../../../model/intent/types";
import EntityForm from "./entityForm/EntityForm";
import { RootState } from "../../../model/rootReducer";
import {createLoadingSelector} from "../../../business/selectors/loadingSelectors";
import Loader from "../../system/loader/Loader";
import ItemManager from "../../system/itemManager/ItemManager";
const EntityItemManager = ItemManager<Entity>();

type IntentFormProps = {};

const EntityManager: React.FunctionComponent<IntentFormProps> = props => {
  const [selectedEntity, setSelectedEntity] = useState<Entity | undefined | null>(null);
  const loadingSelector = createLoadingSelector(['SAVE_ENTITY', 'DELETE_ENTITY']);
  const isFetching = useSelector((state: RootState) => loadingSelector(state));

  const renderMenu = () => {
    return <EntityList selectedEntityId={selectedEntity?.id} onSelect={(intent?: Entity | null) => setSelectedEntity(intent)}/>
  }

  const renderContent = () => {
    return <EntityForm entity={selectedEntity}/>
  }

  return (
    <Loader isLoading={isFetching}>
      <Container>
      <EntityItemManager
        Menu={renderMenu()}
        Content={renderContent()}
        selectedItem={selectedEntity}
      />
      </Container>
    </Loader>
  );
};

export default EntityManager;